module.exports = __webpack_public_path__ + "img/blinkit.54500791.png";